'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlotCone3dIcon = function PlotCone3dIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 32 32' }, props),
        _react2.default.createElement('path', { d: 'M16 3.875c-5.813 0-11.75 1.688-11.75 4.813 0 .75.313 1.438.875 1.938l8.188 15.813c.5 1 1.563 1.625 2.688 1.625s2.188-.625 2.688-1.625l8.188-15.813c.563-.5.875-1.188.875-1.938 0-3.125-5.938-4.813-11.75-4.813zm0 2.25c5.813 0 9 1.563 9.438 2.438L25 9.376c-1.063.813-4.125 1.938-9 1.938s-7.938-1.125-9-1.938l-.438-.813C7 7.688 10.187 6.125 16 6.125zm.688 19.313c-.125.25-.375.438-.688.438s-.563-.188-.688-.438L8.624 12.5c2.375.688 4.875 1.063 7.375 1.063s5-.375 7.375-1.063z' })
    );
};

exports.default = PlotCone3dIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/plotly-icons/lib/components/PlotCone3dIcon.js
// module id = 655
// module chunks = 0